import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useTheme } from "@chakra-ui/system";
import { get, runIfFn, createContext } from "@chakra-ui/utils";
import * as React from "react";
import { transitionConfigToCSS } from "./transition-config";
export function useTransitionConfig(themeKey, props, classNames) {
  var theme = useTheme();
  var path = "components." + themeKey + ".transition";
  var defaultConfig = get(theme, path);
  var configObjectOrFn = props.transitionConfig || defaultConfig;
  var config = runIfFn(configObjectOrFn, props);
  var partsTransitionRef = React.useRef({});
  return React.useMemo(function () {
    if (config) {
      var partsTransition = {};

      for (var _part in config) {
        var _classNames$_part;

        var _config$_part$timeout = config[_part].timeout,
            timeout = _config$_part$timeout === void 0 ? 0 : _config$_part$timeout;
        var className = (_classNames$_part = classNames == null ? void 0 : classNames[_part]) != null ? _classNames$_part : themeKey.toLowerCase();
        var styles = transitionConfigToCSS(config[_part], className);
        partsTransition[_part] = {
          styles: styles,
          timeout: timeout,
          className: className
        };
      }

      var prevTransitionString = JSON.stringify(partsTransitionRef.current);
      var nextTransitionString = JSON.stringify(partsTransition);

      if (nextTransitionString !== prevTransitionString) {
        partsTransitionRef.current = partsTransition;
      }
    }

    return partsTransitionRef.current;
  }, [classNames, config, themeKey]);
}

var _createContext = createContext({
  errorMessage: "useTransitions: `context` is undefined or null. Seems you forgot to wrap the components within <TransitionsProvider />"
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    TransitionsProvider = _createContext2[0],
    useTransitions = _createContext2[1];

export { TransitionsProvider, useTransitions };